/**
 * @return Browser name base on `window.fandomHost.browser`
 */
export function getBrowserName(): string {
  return window.fandomHost?.browser?.split(" ")[0] ?? "";
}
